export default __webpack_public_path__ + "static/media/Equal.b8757177.svg";